export default "https://cdn-static.gokick.com/assets/33ce344a4b715ce65918e7685bcdda5ecb423fac/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";